import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Autocomplete,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  Button,
  CircularProgress,
  InputLabel,
  Typography
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setFormData } from "../../../store/redux/customForms";
import { convertFormsToJson } from "../../../util/utilfunctions/utilFunctions";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
      maxHeight: '35px',
      fontSize: '14px',
      paddingTop: 0,
      paddingBottom: 0,
      marginTop:"0px"
    },
    '& .MuiFormControl-fullWidth': {
        marginTop:"0px"
      },
    '& input': {
      padding: '10px 12px',
      fontSize: '13px',
    },
    '& label': {
      fontSize: '13px',
      top: '-5px',
    },
    '& label.Mui-focused, & label.MuiInputLabel-shrink': {
      top: 0,
      fontSize: '12px',
    },
  }));
  
const CustomDatePicker = styled(DatePicker)({
    '& .MuiInputBase-root': {
      maxHeight: '35px', 
      fontSize: '14px',
    },
})

const CustomFormNew = ({ formName, onSubmit, buttonText = "Submit", loadingButtonText = "Submitting...", loading = false, initialValues }) => {
    const [fields, setFields] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [errors, setErrors] = useState({});
    const [visibleFields, setVisibleFields] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();
    // console.log("initialValues-----------",initialValues)
    // console.log("formName-----------",formName)

    useEffect(() => {
        const fetchForm = async () => {
            try {
                const response = await fetch(`/forms/${formName}.json`);
                const formResponseData = await response.json();
                const convertedForms = convertFormsToJson(formResponseData);
                // console.log("convertedForms-----------",convertedForms)
                const initialVisibility = {};
                convertedForms.forEach(field => {
                    initialVisibility[field.name] = field.name !== "termtype"; // hide `termtype` by default
                });
                // console.log("convertedForms---------",convertedForms)
                setFields(convertedForms);
                setVisibleFields(initialVisibility);
                
                dispatch(setFormData({ formName, data: convertedForms }));
            } catch (error) {
                console.error("Failed to fetch form data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchForm();
    }, [dispatch, formName]);

    useEffect(() => {
        if (fields.length > 0) {
            setFormValues(prev => ({
                ...prev,
                ...initialValues
            }));
        }
    }, [fields, initialValues]);

    const handleChange = (name, value) => {
        console.log("nameeee-----------",name)
        setFormValues(prev => ({ ...prev, [name]: value }));
    };

    const handleValidation = () => {
        const newErrors = {};
        fields.forEach((field) => {
            const { name, validation } = field;
            if (validation?.required && !formValues[name]) {
                newErrors[name] = `${field.label} is required`;
            }
        });
        console.log("newErrors-----------",newErrors)
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            onSubmit(formValues);
        }
    };

    const parseOptions = (options) => {
        return JSON.parse(options)
    };

    const renderField = (field) => {
        const { type, name, label, options, disabled, placeholder } = field;

        if (!visibleFields[name]) return null;

        const value = formValues[name] || "";

        switch (type) {
        case "text":
        case "email":
        case "number":
        case "date":
            return (
                <div className="textfield-container mt-2">
                    <CustomTextField
                        key={name}
                        type={type}
                        label={label}
                        value={value}
                        onChange={(e) => handleChange(name, e.target.value)}
                        placeholder={placeholder}
                        disabled={disabled}
                        error={!!errors[name]}
                        helperText={errors[name]}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxLength: field?.name == "accountentrycomment" ? 90 : (field.maxLength || undefined), min: type == "number" ? 0 : null }}
                        sx={{
                            margin:"0px",
                            width: "100%",
                            borderRadius: "4px",
                            fontFamily: "Inter",
                            fontSize: "12px", 
                            background: "white",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            marginBottom: "4px",
                            marginTop: "0px",
                            '& .MuiInputBase-root': {
                                maxHeight: "40px", 
                                fontSize: "12px", 
                            },
                        }}
                    />
                    {
                        field?.name == "accountentrycomment" && <Typography sx={{fontSize: '12px', color:'grey' }}>(Up to 90 characters allowed)</Typography>
                    }
                </div>
            );

        case "select":
            return (
                <FormControl
                    sx={{
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        margin: "auto",
                        marginBottom: "7px",
                    }}
                    className="mt-1"
                >
                    <Autocomplete
                        key={name}
                        style={{ width: "100%", paddingRight: "0px", paddingLeft: "0px" }}
                        options={options || []}
                        getOptionLabel={(option) => option.label || ""}
                        isOptionEqualToValue={(option, value) => option.value === value}
                        value={options?.find(opt => opt.value === value) || null}
                        onChange={(_, newVal) => handleChange(name, newVal?.value || "")}
                        renderOption={(props, option) => (
                            <li {...props} key={option.value}>
                                {option.label}
                            </li>
                        )}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            error={!!errors[name]}
                            helperText={errors[name]}
                            fullWidth
                            margin="normal"
                            sx={{
                                width: "100%",
                                borderRadius: "4px",
                                fontFamily: "Inter",
                                fontSize: "10px",
                                background: "white",
                                marginBottom: "4px",
                                '& .MuiInputBase-root': {
                                  maxHeight: "40px",
                                  // padding: "6px 10px",
                                  paddingRight: "32px !important",
                                  fontSize: "12px", // Reduced font size of input text
                                },
                            }}
                            InputLabelProps={{
                                style: {
                                  fontSize: "12px",
                                  textAlign: "center",
                                },
                            }}
                        />
                        )}
                        disabled={disabled}
                    />
                </FormControl>
            );

        case "radio":
            return (
                <FormControl key={name} component="fieldset" margin="normal" className="mt-1">
                    <FormLabel component="legend" sx={{ fontSize: "14px", mb: 1 }}>{label}</FormLabel>
                    <RadioGroup
                        row
                        value={value}
                        onChange={(e) => handleChange(name, e.target.value)}
                    >
                        {(Array.isArray(options) ? options : parseOptions(options)).map((opt) => (
                            <FormControlLabel
                                key={opt.value}
                                value={opt.value}
                                control={<Radio sx={{ p: 0.5 }} />}
                                label={opt.label}
                                // disabled={
                                //     (opt.value === "full" && selectedLoan?.outstandingamountwithlatefee <= 0) ||
                                //     (opt.value === "late" && (selectedLoan?.outstandinglatefees <= 0 || totalLateFees <= 0))
                                // }
                                sx={{
                                    mr: 2,
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        fontFamily: 'Inter',
                                        color: '#374151', // Tailwind's gray-700 for example
                                    },
                                }}
                            />
                        ))}
                    </RadioGroup>
                    {errors[name] && <p className="error-text">{errors[name]}</p>}
                </FormControl>
            );

        case "toggle":
            return (
                <FormControlLabel
                    key={name}
                    control={
                        <Switch
                            checked={!!value}
                            onChange={(e) => handleChange(name, e.target.checked)}
                        />
                    }
                    label={label}
                    sx={{ mt: 2 }}
                />
            );

        default:
            return null;
        }
    };

    return (
        <>
            {isLoading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Box display="flex" flexWrap="wrap" gap={2}>
                                {(() => {
                                    const groupedFields = {};

                                    fields.forEach((field) => {
                                        if (!visibleFields[field.name]) return;
                                        const group = field.formgroup || "General";
                                        if (!groupedFields[group]) groupedFields[group] = [];
                                        groupedFields[group].push(field);
                                    });

                                    return Object.entries(groupedFields).map(([groupName, groupFields]) => (
                                        <Box key={groupName} flex={1} minWidth="300px" sx={{ paddingRight: 1 }}>
                                            <Box
                                                fontWeight="bold"
                                                fontSize="14px"
                                                mb={1}
                                                sx={{ color: '#4B5563', fontFamily: 'Nunito' }}
                                            >
                                                {groupName}
                                            </Box>
                                            {groupFields.map((field) => renderField(field))}
                                        </Box>
                                    ));
                                })()}
                            </Box>

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={loading}
                                className="fs-size-12 paiy-green text-white mt-2 custom-loans-form-submit"
                                sx={{ alignSelf: 'flex-start' }}
                            >
                                {loading ? <CircularProgress size={20} color="inherit" /> : buttonText}
                            </Button>
                        </Box>
                    </form>
                )
            }
        </>
    );
};

export default CustomFormNew;
